/**
 *
 * @type {{courses: string, submit: string, password_label: string, about: string, create_an_account: string, my_profile: string, required: string, log_in: string, email_label: string, country_label: string, existing_user: string, explore_courses: string, sign_in: string, sign_out: string}}
 */
const common = {
  app_title: 'Онлайн-навчання для менеджерів середньої ланки (МСЛ)',
  explore_courses: 'Ознайомитися з курсами',
  create_an_account: 'Створити обліковий запис',
  existing_user: 'Вже маєте обліковий запис?',
  log_in: 'Увійти',
  sign_in: 'Увійти',
  sign_out: 'Вийти',
  my_profile: 'Мій Профіль',
  courses: 'Курси',
  about: 'Про нас',
  submit: 'Надіслати',
  email_label: 'Адреса електронної пошти',
  country_label: 'Країна',
  required: 'Усі поля є обов’язковими',
  password_label: 'Пароль',
  undo: 'Скасувати',
  retry: 'Повторити спробу',
  course_sequence_name: 'КУРС {sequence}: {name}',
  newest: 'Найновіші',
  most_popular: 'Найпопулярніші',
  first_name_label: 'Ім\'я',
  last_name_label: 'Прізвище',
  role_label: 'Роль',
  role_name_label: 'Роль Name',
  photo: 'Фото',
  upload_new: 'Завантажити нове',
  continue_: 'Продовжити',
  required_field_message: 'Усі поля є обов’язковими',
  dismiss: 'Відхилити',
  expired_session_message: 'Ваш сеанс закінчився. Будь ласка, увійдіть знову',
  saved: 'Збережено.',
  yes: 'Так',
 




};

/**
 *
 * @type {{h1: string}}
 */
const nav = {
  h1: 'Онлайн-навчання для менеджерів середньої ланки (МСЛ)'
};

/**
 *
 * @type {{subscribe_label: string, subscribe: string, who_office: string, links: string, telephone: string, fax: string, updates: string, subscribe_placeholder: string}}
 */
const footer = {
  links: 'Links',
  who_office: 'Всесвітня організація охорони здоров\'я — Європейське регіональне бюро, UN City, Marmorvej 51, DK-2100 Copenhagen Ø, Denmark',
  telephone: 'Телефон',
  fax: 'Факс',
  updates: 'Updates',
  subscribe_label: 'Please subscribe to receive update[time stamp] [date]hings related to the MLM courses.',
  subscribe: 'Subscribe',
  subscribe_placeholder: 'Your email address',
  subscribe_success_message: 'Your request to be added to the mailing list has been sent',
};

/**
 *
 * @type {{p: string, enroll_course: {small: string, p: string, h3: string}, h1: string, enroll_master: {small: string, p: string, h3: string}, h3: string, welcome: string}}
 */
const home_page = {
  welcome: 'Ласкаво просимо на',
  h1: 'Онлайн-навчання для менеджерів середньої ланки розширеної програми імунізації (РПІ)',
  line_1: `
  Розвивайте свою кар’єру, вивчаючи основні технічні та адміністративні навички, необхідні для проведення програми імунізації на будь-якому рівні. Навчання для МСЛ тепер доступне у вигляді серії з 15 інтерактивних онлайн-курсів, які можна пройти безкоштовно, у власному темпі, будь-коли та будь-де.
  `,
  line_2: `
  У кожному курсі слухачі отримують практичні знання, працюючи з реалістичними сценаріями та прикладами. Після кожного курсу слухачі отримують сертифікат від ВООЗ, що забезпечує кращу продуктивність на роботі та потенціал для кар’єрного росту.
  `,
  enroll_master: {
    small: 'ПРОЙТИ ВСІ 15 КУРСІВ',
    h3: 'Записатися на магістерську програму',
    p: `
    Запишіться на магістерську програму для МСЛ, якщо ви хочете пройти всі 15 онлайн-курсів і оволодіти всіма навичками, необхідними для керівництва та проведення програми імунізації. Час на проходження програми необмежений, всі курси по черзі.
    `,
  },
  enroll_course: {
    small: 'ПРОЙТИ ОКРЕМІ КУРСИ',
    h3: 'Записатися на один з курсів',
    p: `
    Зареєструйтеся на один або кілька онлайн-курсів. Ви можете записатися на будь-яку кількість курсів, щоб опанувати нові або вдосконалити наявні навички. Запишіться на додаткові курси в будь-який час і займайте стільки часу, скільки вам потрібно. Якщо ви пройдете всі 15 курсів, ви отримаєте сертифікат магістра.
    `,
  },
  h3: 'Покращуйте свою ефективність на робочому місці за допомогою онлайн-курсів для МСЛ'
};

/**
 *
 * @type {{frequently_asked_questions: string, faqs: {"0": {head: string, body: string}, "1": {head: string, body: string}, "2": {head: string, body: string}, "3": {head: string, body: string}, "4": {head: string, body: string}, "5": {head: string, body: string}}, h1: string}}
 */
const help_page_original = {
  h1: 'Допомога',
  frequently_asked_questions: 'Поширені запитання',
  faqs: {
    0: {
      slug: 'technology',
      head: 'Які технологічні вимоги до цього онлайн-курсу?',
      body: `
      <p class="text-sm lg:text-base lg:w-9/12 py-3">
      Вам потрібно буде підключитися до Інтернету, щоб пройти курс. Крім того, ці курси розроблено для проходження на настільному комп’ютері чи ноутбуці з використанням останньої версії Chrome, Safari або Firefox.
        </p>
      `,
      subcategories: [
      ]
    },
    1: {
      slug: 'advancing',
      type: 'plain',
      head: 'Are you having trouble entering an answer or advancing to the next activity?',
      body: ``,
      subcategories: [
          {
              slug: 'internet',
              head: 'Internet',
              body: `This is an internet problem. Please note that internet speeds may 
              influence your ability to move through the course. 
              If you are finding that you are having trouble continuing to the next screen, 
              <strong>check your internet connection, clear your cache, and refresh your page accordingly.</strong>`
          }
      ]
    },
    2: {
      slug: 'understanding',
      type: 'columns',
      head: 'Are you having trouble understanding the course content?',
      body: ``,
      subcategories: [
          {slug: 'hint',
           head: 'Use the “Hint” function',
           image: 'help-hint.jpg',
           body: `
           We encourage you to use the <strong>“hint”</strong> functions,
                when they are available. If you no longer have any more “hints”
                available, you can restart the activity and your
                <strong>“hints”</strong> will reset. It will be helpful to write
                down the answers you have already completed prior to restarting
                the activity. Only the current activity will reset; your
                previous progress will remain intact.
           `},
           {slug: 'discussionboard',
           head: 'Use the Обговорення',
           image: 'help-discussionboard.jpg',
           body: `
           If you were not able to derive the answer from the “hints”
                provided, we encourage you to read through the comments posted
                in the discussion board within the course you are completing.
                Your peers may have encountered the same problem and offered
                solutions. If you do not see any suggestions from your peers,
                post a question in the discussion board.
           `},
           {slug: 'resources',
           head: 'Use Course Ресурси',
           image: 'help-resources.jpg',
           body: `
           Each course contains a “Ресурси” section. Here you will find
           several WHO-approved supplementary material available to
           download. If you are having trouble understanding a course, or
           if you have questions beyond the scope of the course, please
           review the provided resources.
           `},
           {slug: 'content',
           head: 'Did you identify an error in the content?',
           body: `
           The MLM courses are based on WHO-approved guidance documents, which are reviewed and updated at regular intervals. Additionally, all course content has been carefully reviewed by WHO subject matter experts. If you think you have identified an error, start by posting a commen[time stamp] [date]he discussion board and ask your peers for their input.
           `},
      ]
    },
    3: {
      slug: 'howworks',
      type: 'stacked',
      head: 'How does MLM Online work?',
      body: ``,
      subcategories: [
          {
              slug: 'enroll',
              head: 'Як записатися на курси?              ',
              image: 'help-enroll.jpg',
              body: `<p class="mb-4">
              Натисніть помаранчеву кнопку «Записатися». Ви можете зареєструватися на один або кілька курсів, які вас зацікавили, або ви можете взяти на себе зобов’язання пройти всі 15 курсів МСЛ для отримання сертифікату магістра. Вибір за вами. Після натискання кнопки «Записатися» вам буде необхідно надати деяку інформацію про себе, свою роль і місцезнаходження. Після цього можна приступати до проходження курсу.
            </p>
            <p>
              Once you click the Enroll button, you will be asked to provide
              some registration information about yourself, your role and
              location. Then you can begin taking the course.
            </p>`,

          },
          {
            slug: 'earn',
            head: 'How do you earn a course certificate?',
            image: '',
            body: `<p class="mb-4">
            Так, якщо ви закінчите курс і пройдете оцінювання, ви отримаєте сертифікат від ВООЗ. <strong>Вам потрібно буде набрати принаймні 80 % балів.</strong> Ви отримаєте сертифікат від ВООЗ за кожен пройдений курс. Наприклад, якщо ви закінчите три курси, ви отримаєте три окремих сертифікати. Крім того, якщо ви завершите всі 15 модулів, ви отримаєте сертифікат магістра.
          </p>`,

        },
        {
            slug: 'access',
            head: 'Як і коли я отримаю свій сертифікат?',
            image: 'help-completed.jpg',
            body: `<p class="mb-4">
            Після завершення онлайн-курсу та проходження оцінювання ви побачите, що ваша сертифікація «в очікуванні». Це пов’язано з тим, що ми хочемо, щоб ви перенесли свої нові знання та навички на своє робоче місце та спробували їх застосувати. Через кілька тижнів ми надішлемо вам коротке опитування, у якому вас запитають, як ви змогли застосувати свої нові навички та знання. Ми хочемо знати, чи був тренінг корисним для вас — і чим саме. Після того, як ви надішлете заповнене опитування, ви отримаєте офіційний сертифікат від ВООЗ.

          </p>`,

        },
        {
            slug: 'master',
            head: 'How do you earn master certification?',
            image: 'help-downloadmaster.jpg',
            body: `<p class="mb-4">
            If you have completed all 15 MLM courses, your master certification will appear at the top of the "courses" page.  
            If you are still unable to access your certificate, it is likely that you received an assessment score <strong>lower than 80%</strong>. 
            Please review your score[time stamp] [date]ll 15 courses to confirm that you received a passing score. 
            Once you have completed all 15 MLM courses, <strong>a link to download your certificate will become available below the image of the green trophy in your 
            "Курси" page.</strong>  
        </p>
        <p class="mb-4">This link will take you to your master certification: <a href="/en/courses">https://app.who-afro-mlm.com/en/courses</a> </p>
        `,

        },
      ]
    },
    4: {
        slug: 'profile',
        type: 'double-stacked',
      head: 'Do you need to update your name, password, photo, or role?',
      body: ``,
      subcategories: [
          {
              slug: 'name',
              head: 'To change the name that appears on your certificate',
              body: `<ul class="mb-4 list-disc ml-5">
              <li class="mb-2">Log in to your MLM account</li> 
              <li class="mb-2">Click on your Name (displayed
            [time stamp] [date]he top right corner of the page).</li> 
              <li class="mb-2">Select “Edit Профіль.”</li>
              <li class="mb-2">In the field titled “Name,” enter your name as you would
              like it to appear on your MLM certificate.</li> 
              <li class="mb-2">To avoid changing
              your password, do not type anything into the “Reset Пароль”
              section.</li> 
              <li class="mb-2">We also encourage you to upload a profile picture
              to your account!</li> 
              <li class="mb-2">Save your changes by clicking the “Save
              Changes” button. Please note that the name in your account
              will appear on your certificate. You may go into your account
              and change your name, however please note that this may be
              done only one time in a span of 3 months.</li>
              </ul>`,
              image: 'help-profile.jpg',
              hiddenimage2: 'help-profile-editprofile.jpg'
          },
          
        {
            slug: 'password',
            head: 'To reset your password',
            body: `<ul class="mb-4 list-disc ml-5">
            <li class="mb-2">Please visit the MLM website and click “log in.” </li>
            <li class="mb-2">Then click on the blue text that says “Забули пароль?” </li>
            <li class="mb-2">Once you enter your email and click the orange reset button,
          you will receive an email instructing you on how to reset your
          password. </li>
          <li class="mb-2">Once this is completed, you will be able to log in
          to your account.</li>
        </ul>`,
            image: 'help-profile-editpassword.jpg',
            hiddenimage1: 'help-profile.jpg'
        },
        {
          slug: 'photo',
          head: 'To change your photo or role',
          body: `<ul class="mb-4 list-disc ml-5">
          <li class="mb-2">Log in to your MLM account</li> 
          <li class="mb-2">Click on your Name in the top right corner of the page.</li> 
          <li class="mb-2">Select “Edit Профіль.”</li> 
          <li class="mb-2">To add or change your photo, select “Завантажити нове photo.”
          </li> 
          <li class="mb-2">To add or change your role, select the drop-down menu titled “Роль.”</li>
        </ul>`,
          image: 'help-profile-editprofile.jpg',
          hiddenimage1: 'help-profile.jpg'
      },
      ]
    },
  }
};


const help_page = {
  h1: 'Допомога',
  frequently_asked_questions: 'Поширені запитання',
  faq: [['Як записатися на курси?',
'Натисніть помаранчеву кнопку «Записатися». Ви можете зареєструватися на один або кілька курсів, які вас зацікавили, або ви можете взяти на себе зобов’язання пройти всі 15 курсів МСЛ для отримання сертифікату магістра. Вибір за вами. Після натискання кнопки «Записатися» вам буде необхідно надати деяку інформацію про себе, свою роль і місцезнаходження. Після цього можна приступати до проходження курсу.'],

['Для кого призначене це навчання?',
'Навчання орієнтоване на фахівців з імунізації на рівні менеджерів — осіб, які відповідають за нагляд за програмою РПІ у своїй географічній зоні. Типовий менеджер РПІ повинен успішно завершити ці курси. Якщо ви медичний працівник або менеджер, який вперше працюватиме у сфері імунізації, ви можете спочатку переглянути відеоуроки на IA Watch, щоб отримати необхідні базові навички та знання.'],

['Чи відрізняються ці курси від тренінгів для МСЛ, які проводять в аудиторії?',
'Досвід курсу різний, оскільки різною є модальність навчання. Проте як аудиторні заняття, так і онлайн-навчання для МСЛ створені з використанням однієї інформації від ВООЗ, і обидва тренінги охоплюють однакові навички та знання. Обидва вони були створені за допомогою експертів із відповідної тематики з ВООЗ AFRO.'],

['Чи отримаю я сертифікат за проходження курсу?',
'Так, якщо ви закінчите курс і пройдете оцінювання, ви отримаєте сертифікат від ВООЗ. Вам потрібно буде набрати принаймні 80 % балів. Ви отримаєте сертифікат від ВООЗ за кожен пройдений курс. Наприклад, якщо ви закінчите три курси, ви отримаєте три окремих сертифікати. Крім того, якщо ви завершите всі 15 модулів, ви отримаєте сертифікат магістра.'],

['Як і коли я отримаю свій сертифікат?',
'Після завершення онлайн-курсу та проходження оцінювання ви побачите, що ваша сертифікація «в очікуванні». Це пов’язано з тим, що ми хочемо, щоб ви перенесли свої нові знання та навички на своє робоче місце та спробували їх застосувати. Через кілька тижнів ми надішлемо вам коротке опитування, у якому вас запитають, як ви змогли застосувати свої нові навички та знання. Ми хочемо знати, чи був тренінг корисним для вас — і чим саме. Після того, як ви надішлете заповнене опитування, ви отримаєте офіційний сертифікат від ВООЗ.'],

['Які технологічні вимоги до цього онлайн-курсу?',
'Вам потрібно буде підключитися до Інтернету, щоб пройти курс. Крім того, ці курси розроблено для проходження на настільному комп’ютері чи ноутбуці з використанням останньої версії Chrome, Safari або Firefox.']
  ]
}
/**
 *
 * @type {{"0": {p: string, button: string, h1: string}, "1": {p: string, button: string, h1: string}}}
 */
const about_page = {
    section_1: {
      h1: 'Про курси для МСЛ',
      p: `
      Вдосконалюйте свою ефективність на робочому місці, пройшовши один або кілька з 15 окремих курсів, наведених нижче. У кожному курсі ви отримаєте відповідну практику, індивідуальний зворотний звʼязок, набір ресурсів і матеріалів ВООЗ, а також доступ до спільноти таких самих слухачів, як і ви. Натисніть на кнопку курсу, щоб побачити, що саме він охоплює. І приступайте до навчання.
      `,
      button: 'Перейти до курсів '
    },
    section_2: {
      h1: 'Сертифікація наступного рівня за магістерською програмою для МСЛ',
      line_1: `
      Розвивайте свою кар’єру, записавшись на магістерську програму для МСЛ. Після зарахування ви автоматично зареєструєтеся на всі 15 курсів, наведених нижче. Приділіть виконанню курсової роботи стільки часу, скільки вам потрібно. Протягом усієї програми ви отримаєте відповідну практику, індивідуальний відгук, набір ресурсів і матеріалів ВООЗ, а також доступ до спільноти таких самих слухачів, як і ви. Після закінчення ви отримаєте сертифікат магістра від ВООЗ на знак вашої майстерності та відданості.
      `,
      line_2: `
      `,
      button: 'Переглянути всі курси'
    },
  };

/**
 *
 * @type {{est_time: string, you_are_enrolled: string, completed_courses: string, all_mlm_courses: string, view_details: string, enroll_master: string, enrolled_courses: string, enroll_in_courses: string, complete_the_remaining_n_courses: string, what_do_you_want_to_learn_about: string, continue_course: string, course_sequence_name: string, you_have_completed_all_courses: string, you_can_retake_courses_anytime: string, search_error_message: string, download_master_cert: string, you_have_completed_n_courses: string, my_courses: string, mlm_master_cert: string, download_cert: string, course_sequence: string, improve_your_performance: string, see_your_courses_below: string, start_course: string, enroll_success_message: string, great_start: string, search_results: string, n_courses: string, progress: string, enroll: string}}
 */
const courses_page = {
  improve_your_performance: 'Покращуйте свою ефективність на робочому місці за допомогою онлайн-курсів для МСЛ',
  enroll_in_courses: 'Запишіться на один із наведених нижче курсів або зареєструйтеся на магістерську програму сертифікації для МСЛ.',
  great_start: 'Створення облікового запису – чудовий початок! Ви на шляху до отримання сертифікату МСЛ.',
  you_are_enrolled: 'Успішно! Ви зареєстровані на магістерську програму сертифікації для МСЛ і вже на шляху до отримання сертифікату.',
  see_your_courses_below: 'Перегляньте перелік ваших курсів нижче.',
  n_courses: '{n} курс | {n} курси',
  you_have_completed_n_courses: 'Так тримати! Кількість завершених курсів даний момент: {courses}',
  complete_the_remaining_n_courses: 'Пройдіть ще {courses} курс/и/ів для отримання сертифікату магістра МСЛ.',
  you_have_completed_all_courses: 'Вітаємо! Ви щойно склали 15-е оцінювання. Ви офіційно завершили всі курси магістерської програми сертифікації для МСЛ',
  you_can_retake_courses_anytime: 'Не забувайте оновлювати свої знання. Ви можете пройти курси повторно у будь-який час.',
  download_master_cert: 'Завантажити магістерську сертифікат',
  download_cert: 'Завантажити сертифікат',
  search_results: 'Результати пошуку',
  all_mlm_courses: 'Всі курси для МСЛ',
  what_do_you_want_to_learn_about: 'Про що ви хочете дізнатися?',
  course_sequence: 'КУРС {sequence}',
  course_sequence_name: common.course_sequence_name,
  view_details: 'Докладніше',
  est_time: 'Приблизний час {time}',
  estimated_time: 'Приблизний час',
  enroll: 'Записатися',
  enroll_now: 'Записатися зараз',
  mlm_master_cert: 'Сертифікація за магістерською програмою для МСЛ',
  enroll_master: `Записатися на всі 15 курсів одразу. Приділіть виконанню курсової роботи стільки часу, скільки вам потрібно. Після закінчення ви отримаєте сертифікат магістра від ВООЗ.`,
  search_error_message: 'Ваш пошук не дав жодного модуля. Спробуйте інший пошук.',
  my_courses: 'Мої курси',
  enrolled_courses: 'Зареєстровані курси',
  progress: 'Прогрес',
  completed_courses: 'Завершені курси',
  retake_course: 'Повторно пройти курс',
  continue_course: 'Продовжити курс',
  start_course: 'Почати курс',
  enroll_success_message: 'Ви зараховані на {course_sequence_name}',
  module_available_soon: 'Цей модуль незабаром буде доступний',
  master_enroll_error_message: 'талася помилка, на деякі курси Ви не були зараховані',
  master_un_enroll_error_message: 'Сталася помилка, деякі курси не були скасовані',
  master_enroll_success_message: 'Ви зараховані на всі 15 курсів',
  lessons: 'Уроки',
  view_my_results: 'Переглянути мої результати',
  course: 'Курс',
  date_completed: 'Дата завершення',
  results: 'Результати',
  course_results: 'Результати курсу',
  for: 'для',
  new_courses: 'Beginning April 2021, a new course, titled 2YL and Beyond, will also be required for MLM master certification.',
};

/**
 *
 * @type {{return_to_my_courses: string, hide_menu: string, ask_your_question_below: string, ask_an_expert: string, ask_question_here: string, restart: string, start: string, submit_question: string, resources: string, show_menu: string, no_more_activities: string, ask_expert_success_message: string}}
 */
const course_page = {
  ask_expert_success_message: 'Your message has been sent',
  no_more_activities: 'У цьому курсі більше немає вправ',
  hide_menu: 'Приховати меню',
  show_menu: 'Показати меню',
  restart: 'Розпочати знову',
  next_up: 'Далі Up',
  start: 'Почати',
  return_to_my_courses: 'Мої курси',
  resources: 'Ресурси',
  ask_an_expert: 'Ask an Expert',
  ask_your_question_below: 'Ask your question below to contact a subject matter expert and they will follow up shortly with an email.',
  ask_question_here: 'Ask a question here',
  submit_question: 'Надіслати Question',
  discussion_board: 'Обговорення',
  add_comment: 'Додати коментар',
  sort_by: 'Сортувати за:',
  view_n_more_comments: 'Переглянути ще {n} коментарів',
  reply: 'Відповісти',
  reply_to_author: 'Відповісти @{author}',
  share: 'Share',
  like_this: 'Подобається',
  liked: 'Сподобалось',
  need_help: 'Потрібна допомога?',
};

/**
 *
 * @type {{profile_information: string, edit_profile: string}}
 */
const profile_page = {
  edit_profile: 'Редагувати профіль',
  profile_information: 'Інформація профілю',
};

/**
 *
 * @type {{}}
 */
const profile_edit_page = {
  profile_settings: 'Налаштування профілю',
  profile: 'Профіль',
  reset_password: 'Скинути пароль',
  return_to_profile: 'Повернутися до профілю',
  first_name_label: common.first_name_label,
  last_name_label: common.last_name_label,
  country_label: common.country_label,
  role_label: common.role_label,
  role_name_label: common.role_name_label,
  email_label: 'Адреса електронної пошти',
  mobile_phone_label: 'Мобільний телефон',
  save_changes: 'Зберегти зміни',
  cancel: 'Відмінити',
  new_password_label: 'Новий пароль',
  confirm_password_label: 'Підтвердити пароль',
  reset_success_response: 'Ваше посилання для скидання надіслано! Будь ласка, перевірте свою електронну пошту.',
  send_reset_link: 'Відправити посилання для скидання паролю'
};

/**
 *
 * @type {{}}
 */
const survey_page = {
  please_message: 'Please complete this survey based on your experiences since taking the course.',
  thanks_message: 'Thank you for completing the survey.',
  h1: '{name}, you have successfully completed {module}',
  h2: 'WHO AFRO MLM Training: Online Survey',
  line_1: 'This small survey will help The WHO AFRO IVD program to better understand how the MLM course material is utilized in the day-to-day work of mid-level immunization program managers.',
  line_2: `In addition, this step has been built in as a requirement in order to receive certification for the
  training. We kindly ask that you complete this 9-question survey, which takes no more than 10
  minutes. Once you complete the survey, you will receive certification from WHO AFRO for the
  completed training.`,
  line_3: 'Thank you for taking your time to provide your experiences.',
  capable_label_line_1: 'To what extent did this MLM online course make you feel more capable of doing your job?',
  capable_label_line_2: 'Please rate from Less Capable (1) to Most Capable (10)',
  swipe_to_see_more: 'Swipe to see more',
  less_capable: 'less capable',
  most_capable: 'most capable',
  ways_used_line_1: 'Think about your work experiences over the past two months. In what way have you used the skills and knowledge you gained through this online module in your daily work?',
  ways_used_line_2: 'Provide an example that is as specific as possible.',
  write_your_answer_here: 'Write your answer here...',
  measurable_improvement_label: `
  In what {measurable_way} have you seen an improvement in
  the performance of your immunization program, as a result of your new skills and knowledge?`,
  measurable_way: 'measurable way',
  anything_else_label: 'Is there anything else you would like to share about the impact of the learning experience?',
  final_thanks: 'Thank you for your participation in this survey and your commitment to your profession. This was the final step of MLM training.'
};

/**
 *
 * @type {{}}
 */
const reset_page = {

};

/**
 *
 * @type {{thank_you: string, response_message: string, email_label: string, country_label: string, h1: string, h2: string, describe_label: string, required: string, name_label: string, title_label: string}}
 */
const contact_modal = {
  h1: 'Контактна інформація',
  h2: 'Контактна інформація an officer at WHO AFRO headquarters in Brazzaville. They will respond to your message as soon as possible.',
  required: common.required,
  name_label: 'Name',
  title_label: 'Title',
  email_label: common.email_label,
  country_label: common.country_label,
  describe_label: 'Describe Your Training Need',
  thank_you: 'Thank You',
  response_message: 'An officer at WHO AFRO headquarters in Brazzaville will respond to your message as soon as possible.',
};

/**
 *
 * @type {{role_name_label: string, register_now: string, last_name_label: string, basic_info: string, upload_new: string, password_label: string, first_name_label: string, h1: string, photo: string, h2: string, optional: string, contact_info: string, enroll_mlm_label: string, password_confirmation_label: string, registered_user: string, country_label: string, email_label: string, role_label: string, email_confirmation_label: string, sign_in: string}}
 */
const register_modal = {
  h1: 'Зареєструйтеся для того щоб розпочати з Онлайн-навчання для менеджерів середньої ланки (МСЛ).',
  h2: 'Саме так ваше ім’я буде зазначено на сертифікатах, які ви отримаєте, тому, будь ласка, будьте уважні при введенні свого імені.',
  registered_user: 'Вже зареєстровані?',
  sign_in: 'Увійти',
  basic_info: 'Основна інформація',
  contact_info: 'Контактна інформація Information',
  first_name_label: common.first_name_label,
  last_name_label: common.last_name_label,
  country_label: common.country_label,
  role_label: common.role_label,
  role_name_label: common.role_name_label,
  password_label: common.password_label,
  password_confirmation_label: 'Підтвердити пароль',
  email_label: common.email_label,
  email_confirmation_label: 'Підтвердіть адресу електронної пошти',
  photo: common.photo,
  optional: 'Додатково',
  upload_new: common.upload_new,
  enroll_mlm_label: 'Записатися на магістерську програму для МСЛ',
  register_now: 'Надіслати',
};

/**
 *
 * @type {{email_label: string, password_label: string, or_register_an_account: string, h1: string, forgot_password: string}}
 */
const login_modal = {
  h1: 'Увійти у свій обліковий запис',
  email_label: common.email_label,
  password_label: common.password_label,
  forgot_password: 'Забули пароль?',
  or_register_an_account: 'Створити обліковий запис'
};

/**
 *
 * @type {{playback_step_1: string, playback_step_2: string, playback_step_3: string, back_btn_text: string, tour_btn_text: string, done_btn_text: string, start_step: string, next_btn_text: string, collaborate_step_2: string, collaborate_step_3: string, collaborate_step_4: string, collaborate_step_1_lg: string, collaborate_step_1_sm: string}}
 */
const tour = {
  start_step: 'Ласкаво просимо на ваш перший курс для МСЛ! Запрошуємо у тур...',
  playback_step_1: 'Ваш курс з\'явиться тут.',
  playback_step_2: 'Під час проходження курсу натисніть кнопку «ДАЛІ», щоб перейти до наступного екрана курсу.',
  playback_step_3: 'Ви можете запустити спочатку або переглянути будь-який розділ курсу, натиснувши відповідну кнопку.',
  collaborate_step_1_sm: 'You may show/hide all sections of the course by clicking here.',
  collaborate_step_1_lg: 'Натисніть тут, щоб курс розкрився на весь екран.',
  collaborate_step_2: 'Діліться своїми запитаннями, знаннями та порадами з іншими фахівцями РПІ, які проходять цей курс разом з вами.',
  collaborate_step_3: 'Кожен курс містить корисні ресурси, які можуть вам знадобитися. Ви можете завантажити їх, натиснувши такі значки.',
  collaborate_step_4: 'If you cannot find the answers you need by talking with other[time stamp] [date]he Обговорення, we recommend that you visit the online Допомога Page ',
  tour_btn_text: 'ЗДІЙСНИТИ ТУР',
  back_btn_text: 'Назад',
  next_btn_text: 'Далі',
  done_btn_text: 'Готово',
};

const workshops = {
  heading: 'EPI Mid-Level Managers training has been redesigned to be more effective, flexible, and interactive. Each module now exists as a workshop and an online emodule – in English, French and Portuguese. Download any workshop materials below.',
  redesigned_workshops: 'Redesigned workshops',
  number_workshops: '17 modularized workshops that can be delivered in any combination',
  guides: 'Facilitator’s and participant’s guides',
  instructions: 'Minute-by-minute instructions for facilitators leading each workshop',
  specific_points: 'Specific exercises, activities, and lecture points',
  structured_pedagogy: 'Structured pedagogy support throughout',
  workshops: 'Workshops',
  download_materials: 'Download materials',
  online_curriculum: 'An online curriculum',
  same_content: 'Same content as the workshops',
  self_paced: 'Self-paced learning',
  highly_modular: 'Highly modular',
  go_to: 'Go to the Онлайн-навчання для менеджерів середньої ланки (МСЛ)',
  courses: 'Курси',
  about: 'Про нас',
  help: 'Допомога',
  address: 'World Health Organization - Regional Office for Africa Cité du Djoué, P.O. Box 06 Brazzaville Republic of Congo',
  telephone: 'Telephone',
  fax: 'Fax',
}

/**
 *
 */
export default {
  ...common,
  nav,
  footer,
  home_page,
  help_page,
  about_page,
  courses_page,
  course_page,
  profile_page,
  profile_edit_page,
  survey_page,
  reset_page,
  contact_modal,
  register_modal,
  login_modal,
  tour,
  workshops,
}